import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { Dispatch, SetStateAction, memo, useState } from 'react'
import { TaskDetailRelatedInfoListToolbar } from './components/taskDetailRelatedInfoListToolbar/taskDetailRelatedInfoListToolbar'
import { TaskDetailRelatedInfoListPanel } from './components/taskDetailRelatedInfoListPanel/taskDetailRelatedInfoListPanel'
import { createUninitializedContext } from '@crew/utils/context'
import { RelatedSuggestion_Item } from '@crew/models/domain'

export type SuggestionItem = {
  id: string // entityType + entityRecordId
} & RelatedSuggestion_Item

/** 関連情報表示の状態 */
type RelatedInfoDisplayState = 'relatedInfo' | 'searching' | 'suggestion'

/** Context用の型 */
type TaskDetailRelatedInfoListContextType = {
  // 関連情報表示の状態
  displayState: RelatedInfoDisplayState
  // 関連情報表示の状態を更新する関数
  setDisplayState: Dispatch<SetStateAction<RelatedInfoDisplayState>>
  // 生成された関連提案情報
  relatedSuggestions: SuggestionItem[]
  // 生成された関連提案情報を更新する関数
  setRelatedSuggestions: Dispatch<SetStateAction<SuggestionItem[]>>
  // 関連提案行選択状態
  selectedSuggestions: SuggestionItem[]
  // 関連提案行選択状態を更新する関数
  setSelectedSuggestions: Dispatch<SetStateAction<SuggestionItem[]>>
}

/** Context */
const {
  context: taskDetailRelatedInfoListContext,
  useInitializedContext: useTaskDetailRelatedInfoListContext,
} = createUninitializedContext<TaskDetailRelatedInfoListContextType>()

export { useTaskDetailRelatedInfoListContext }

export const TaskDetailRelatedInfoList = memo(() => {
  // 関連情報表示の状態(初期状態は関連情報表示)
  const [displayState, setDisplayState] =
    useState<RelatedInfoDisplayState>('relatedInfo')

  // 生成された関連提案情報
  const [relatedSuggestions, setRelatedSuggestions] = useState<
    SuggestionItem[]
  >([])

  // 関連提案行選択状態
  const [selectedSuggestions, setSelectedSuggestions] = useState<
    SuggestionItem[]
  >([])

  return (
    <taskDetailRelatedInfoListContext.Provider
      value={{
        displayState,
        setDisplayState,
        relatedSuggestions,
        setRelatedSuggestions,
        selectedSuggestions,
        setSelectedSuggestions,
      }}
    >
      <CrewErrorBoundary>
        {/* 関連情報ツールバー */}
        <TaskDetailRelatedInfoListToolbar />
      </CrewErrorBoundary>
      <CrewErrorBoundary>
        {/* 関連情報・関連提案 */}
        <TaskDetailRelatedInfoListPanel />
      </CrewErrorBoundary>
    </taskDetailRelatedInfoListContext.Provider>
  )
})
